import * as React from "react";
import classnames from "classnames";
import { Util, RichTextArea, Link } from "@grandvisionhq/common";
import { Container } from "@grandvisionhq/elements";
import { BannerTooltip } from "../../../BannerTooltip/components/BannerTooltip/BannerTooltip.js";
import LazyPicture from "../../../LazyPicture/components/LazyPicture/LazyPicture.js";
/* empty css                */
const regHex = /#([a-f0-9]{3}){1,2}\b/i;
const regPresetBg = /black|grey|white/;
const RichBanner = ({
  image,
  mobileImage,
  link,
  richText,
  layout,
  bannerWidth,
  imageWidth,
  imageAlignment = "left",
  backgroundColor,
  textColor = "black",
  ctaAlignment: childrenAlignment,
  children,
  tooltip
}) => {
  if (!image && !richText) {
    console.warn(`Cannot render RichBanner: missing content`);
    return null;
  }
  const ContainerComponent = bannerWidth === "contained" ? Container : React.Fragment;
  let imgSizes;
  if (bannerWidth === "contained") {
    imgSizes = {
      M: 768,
      L: 1024,
      XL: 1370,
      MAX: 1370
    };
  }
  const classNames = classnames(
    "rich-banner",
    `rich-banner--image-alignment-${imageAlignment}`,
    `rich-banner--text-color-${textColor}`,
    {
      [`rich-banner--image-width-${imageWidth}`]: image && imageWidth,
      [`rich-banner--layout-${layout}`]: layout
    }
  );
  const richBannerStyle = {};
  if (backgroundColor) {
    richBannerStyle.backgroundColor = regHex.test(backgroundColor) ? backgroundColor : regPresetBg.test(backgroundColor) ? Util.colorHexMap[backgroundColor] : "transparent";
  }
  const bannerContent = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "rich-banner__content" }, richText && /* @__PURE__ */ React.createElement(
    RichTextArea,
    {
      className: "rich-banner__rich-text",
      content: richText,
      textColor
    }
  )), children && /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames("rich-banner__children", {
        [`rich-banner__children--${childrenAlignment}`]: !!childrenAlignment
      })
    },
    children
  ));
  return /* @__PURE__ */ React.createElement(ContainerComponent, null, /* @__PURE__ */ React.createElement("div", { className: classNames, style: richBannerStyle }, image && /* @__PURE__ */ React.createElement("div", { className: "rich-banner__slot rich-banner__slot--primary" }, link ? /* @__PURE__ */ React.createElement(Link, { className: "rich-banner__link", url: link.url, target: link.target }, link.label && /* @__PURE__ */ React.createElement("span", { className: "rich-banner__link-text" }, link.label), /* @__PURE__ */ React.createElement(
    LazyPicture,
    {
      className: "rich-banner__picture",
      mobileImage,
      image,
      imgSizes
    }
  )) : /* @__PURE__ */ React.createElement(
    LazyPicture,
    {
      className: "rich-banner__picture",
      mobileImage,
      image,
      imgSizes
    }
  ), tooltip && /* @__PURE__ */ React.createElement(BannerTooltip, { className: "rich-banner__tooltip", tooltip })), richText && /* @__PURE__ */ React.createElement("aside", { className: "rich-banner__slot rich-banner__slot--secondary" }, bannerWidth !== "contained" && imageWidth === "100" ? /* @__PURE__ */ React.createElement(Container, null, bannerContent) : /* @__PURE__ */ React.createElement(React.Fragment, null, bannerContent))));
};
export {
  RichBanner,
  RichBanner as default
};
//# sourceMappingURL=RichBanner.js.map
